// Public surface for shared UI primitives.
// Per CLAUDE.md §3, cross-module imports go through barrels — outsiders
// import `@/shared/ui` (or a sub-barrel like `@/shared/ui/layout`),
// not the individual SFC files.

export { default as SiteHeader } from "./layout/SiteHeader.vue";
export { default as SiteFooter } from "./layout/SiteFooter.vue";
